const o = Symbol("_ref");
export {
  o as REF
};
